import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type OrderEmailRecipientRoutingStateFragment = { __typename?: 'OrderEmailRecipientRoutingStateData', tenantId: string, entries: Array<{ __typename?: 'OrderEmailRecipientRoutingEntryData', docType: Types.OrderEmailRecipientDocType, contactType: Types.ContactType }> };

export type GetOrderEmailRecipientRoutingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrderEmailRecipientRoutingQuery = { __typename?: 'Query', orderEmailRecipientRouting?: { __typename?: 'OrderEmailRecipientRoutingDocument', tenantId: string, entries: Array<{ __typename?: 'OrderEmailRecipientRoutingEntryDocument', docType: Types.OrderEmailRecipientDocType, contactType: Types.ContactType }> } | null };

export const OrderEmailRecipientRoutingStateFragmentDoc = new TypedDocumentString(`
    fragment OrderEmailRecipientRoutingState on OrderEmailRecipientRoutingStateData {
  tenantId
  entries {
    docType
    contactType
  }
}
    `, {"fragmentName":"OrderEmailRecipientRoutingState"});
export const GetOrderEmailRecipientRoutingDocument = new TypedDocumentString(`
    query GetOrderEmailRecipientRouting {
  orderEmailRecipientRouting {
    tenantId
    entries {
      docType
      contactType
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOrderEmailRecipientRouting: build.query<GetOrderEmailRecipientRoutingQuery, GetOrderEmailRecipientRoutingQueryVariables | void>({
      query: (variables) => ({ document: GetOrderEmailRecipientRoutingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOrderEmailRecipientRoutingQuery, useLazyGetOrderEmailRecipientRoutingQuery } = injectedRtkApi;
